<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
      <div class="mb3 text-left">
         <span class="induk">{{form.no_permohonan}}</span> | <w-tag class="mr4" bg-color="primary" round> {{form.lkp_status_anak_keterangan}} </w-tag>
      </div>

      <z-page :title="title">
         <w-form 
                   ref="zform" 
                   v-model="valid" 
                   v-model:errors-count="errorsCount" 
                   @submit.prevent="validateForm" 
                   @success="success"
                 >
        <div class="w-flex wrap smd-column" >
          <div class="grow " > 
            <table width="100%">
              <tbody>
               <tr class="row_data">
                  <td width="50%">
                     <table width="100%">
                      <tbody>
                        <tr class="row_data">
                            <td colspan="3"><b><u>MAKLUMAT INDUK</u></b></td>
                        </tr>
                        <tr class="row_data">
                            <td width="40%"><b>No. Pendaftaran Induk</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.no_pendaftaran}}</td>
                        </tr>
                        <tr class="row_data">
                            <td width="40%"><b>ID | Nama Induk</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.induk}} | {{form.nama_induk}}</td>
                        </tr>
                        <tr class="row_data">
                            <td width="40%"><b>Generasi Induk</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.induk_gred}}</td>
                        </tr>
                        <tr class="row_data">
                            <td width="40%"><b>Baka Induk</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.induk_baka}}</td>
                        </tr>
                        </tbody>
                      </table>
                  </td>
                  <td width="50%">
                     <table  width="100%">
                      <tbody>
                        <tr class="row_data">
                            <td colspan="3"><b><u>MAKLUMAT PEJANTAN</u></b></td>
                        </tr>
                        <tr class="row_data">
                            <td width="40%"><b>ID Pejantan</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.pejantan}}</td>
                        </tr>

                        <tr class="row_data">
                            <td width="40%"><b>Baka Pejantan</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.pejantan_baka}}</td>
                        </tr>
                        <tr class="row_data" v-if="form.penderma">
                            <td width="40%"><b>ID Pederma</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.penderma}}</td>
                        </tr>
                        <tr class="row_data" v-if="form.penderma">
                            <td width="40%"><b>Baka Pederma</b></td>
                            <td width="2%"><b>:</b></td>
                            <td width="58%">{{form.penderma_baka}}</td>
                        </tr>
                        <tr class="row_data" v-else>
                            <td colspan="3"><b>&nbsp;</b></td>
                        </tr>
                        </tbody>
                     </table>
                 </td>
             </tr>
             </tbody>
         </table>
        <br>
            <table  width="100%">
              <tbody>
                <tr class="row_data">
                    <td colspan="3"><b><u>MAKLUMAT ANAK</u></b></td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>ID | Nama Premis</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{form.no_premis}} | {{form.nama_premis}}</td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>No Kes</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{form.no_kes}}</td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>Tarikh Laporan</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{$zutil.dateformat(form.tarikh_laporan)}}</td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>Generasi Anak</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">
                        <template v-if="$zutil.anyRole(['4'])">
                            <template  v-if="form.lkp_status_anak_id == 34" >
                                <z-select style="margin:5px; " class="mt4"  :items="gred" v-model="form.lkp_gred_id" :validators="[validators.required]"/>
                            </template>
                            <template v-else>
                                {{form.gred}}
                            </template>
                        </template>
                        <template v-else>
                            {{form.gred}}
                        </template>
                    </td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>Baka Anak</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{form.baka}}</td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>Nama Juruteknik/Jurusuntik</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{form.nama_jurukteknik}} </td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>No. Batch</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{form.no_batch}} </td>
                </tr>
                <tr class="row_data">
                   <td width="20%"><b>Bilangan Anak</b></td>
                   <td width="1%"><b>:</b></td>
                   <td width="79%">{{form.bilangan_anak}} </td>
                </tr>
                </tbody>
              </table>


            
            
            
             
          </div>
          <div class="mx2"></div>
          <div class="grow " >
            <!-- <div  v-if="form.id > 0">
              
             <vueper-slides fade :touchable="false" fixed-height="300px">
                <vueper-slide v-for="(slide, i) in slides"  :key="i"  :image="slide.image"  />
              </vueper-slides>
             <template v-if="$zutil.anyRole(['1', '2', '5'])">
                <w-input type="file" :preview="false" accept=" image/*" @input="uploadImg('\\App\\Model\\ArtButiran')" v-model="files" multiple>Muat Naik Gambar</w-input>
                <template v-for="dt, ind  in attahecment">
                  <div class="fw-normal my1 fs-1">  
                    <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                  </div>
                </template>
              </template>
            </div> -->
          </div>
      </div>

        <br>
      <div class="w-table w-table--wrap">
                <div class="w-table__scroll-wrap" >
                  <table class="w-table" color="light" >
                    <thead>
                      <tr>
                        <th class="w-table__header  text-left" width="1%">No</th>
                      <th class="w-table__header  text-left" >Status Kelahiran *</th>
                      <th class="w-table__header  text-left" >Tarikh Lahir</th>
                      <th class="w-table__header  text-left" >Catatan</th>
                      <th class="w-table__header  text-left" >ID Ternakan</th>
                      <th class="w-table__header  text-left" >Nama Ternakan</th>
                      <th class="w-table__header  text-left" >Jantina *</th>
                      <th class="w-table__header  text-left" >Kaedah Kelahiran *</th>
                      <th class="w-table__header  text-left" >Berat Lahir (Kg)</th>
                      <th class="w-table__header  text-left" >Warna Bulu</th>
                      <th class="w-table__header  text-left" >Cacat</th>
                      <th class="w-table__header  text-left" >Gambar Ternakan</th>
                      <th class="w-table__header  text-left" >Tindakan</th>
                      </tr>
                    </thead>

                    <tbody>
                      
                      <template v-for="(dt, ind) in form.anak">
                        <tr class="w-table__row" >
                          <td class="w-table__cell text-left" >{{ind+1}}</td>
                          <td class="w-table__cell text-left" >
                            {{dt.status_label}}
                          </td>
                          <td class="w-table__cell text-left" >
                            {{$zutil.dateformat(dt.tarikh_lahir)}}
                          </td>
                          <td class="w-table__cell text-left" >
                            {{dt.nyatakan_kelahiran}}
                          </td>
                          <td class="w-table__cell text-left" >
                            {{dt.kode_ternakan}}
                          </td>
                          <td class="w-table__cell text-left" >
                            {{dt.nama}}
                          </td>
                          <td class="w-table__cell text-left" >
                            {{dt.jantina_label}}
                          </td>
                          <td class="w-table__cell text-left" >
                            {{dt.kaedah_kelahiran_label}}
                          </td>
                          <td class="w-table__cell text-center" >
                            {{dt.berat}}
                          </td>
                          <td class="w-table__cell text-center" >
                            <template v-if="$zutil.anyRole(['4'])">
                                <template  v-if="form.lkp_status_anak_id == 34" >
                                    <z-select style="margin:5px; " class="mt4"  :items="lkp_warna" v-model="dt.lkp_warna_id" :validators="[validators.required]"/>
                                </template>
                                <template v-else>
                                    {{dt.warna_bulu}}
                                </template>
                            </template>
                            <template v-else>
                                {{dt.warna_bulu}}
                            </template>
                          </td>
                          <td class="w-table__cell text-center" >
                            <template v-if="dt.cacat == 1">Tidak</template>
                            <template v-else>Ya ({{dt.nyatakan_cacat}})</template>
                          </td>

                          <td class="w-table__cell text-center" >
                                <template v-for="d, ind  in dt.atthectment_image">
                                       <div class="fw-normal my1 fs-1">  
                                            <!-- <a :href="d.url">{{ d.name }}</a>  -->
                                            <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(d.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                                            <br>
                                        <a :href="d.url" target="_blank" rel="noopener">
                                            <vueper-slides fade fixed-height="150px" :touchable="true">
                                                <vueper-slide :image="d.url" />
                                            </vueper-slides>
                                        </a>
                                       </div>
                                </template>
                            </td>

                            <td class="w-table__cell text-center" >
                                <!-- <w-button bg-color="success" class="mr3" @click="cetak(dt.id)" v-if="item.lkp_art_id == 1 || item.lkp_art_id == 3"> -->
                                <w-button bg-color="success" class="mr3" @click="cetak(dt.id)" v-if="form.lkp_status_anak_id == 21 || form.lkp_status_anak_id == 22">
                                    <w-icon>fal fa-print</w-icon>&nbsp;CETAK
                                </w-button>
                            </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
             </div>
                      <br>
                      <br>

            <template  v-if="$zutil.anyRole(['4']) && form.lkp_status_anak_id == 34" >
            <w-card 
                 title-class="blue-dark4--bg white" 
                 style="font-size: 13px;" 
                 :title="'STATUS PERMOHONAN ANAK'"
               >
                <!--  <w-form 
                   ref="zform" 
                   v-model="valid" 
                   v-model:errors-count="errorsCount" 
                   @submit.prevent="validateForm" 
                   @success="success"
                 > -->
                   <template #title>
                     STATUS
                   </template>

                   <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
                     
                      <w-radios
                        v-model="form_anak.lkp_status_anak_id"
                        :items="[
                                 { value: 21, label: 'Tolak' },
                                 { value: 22, label: 'Lulus' },
                              ]"
                        inline
                        :validators="[validators.required]"
                        color="blue-dark3"
                      />
                      <br>
                      <br>


                     <w-input 
                            label="Catatan" 
                            type="textarea"
                            v-model="form_anak.nyatakan_status_anak" 
                            v-if="form_anak.lkp_status_anak_id == 21"
                            :validators="[
                              form_anak.lkp_status_anak_id == 21 ? validators.required : null
                            ]"
                            outlined 
                            rows="4"
                          />
                   </div>
                 <!-- </w-form> -->
               </w-card>


            </template>
          </w-form>
            <br>
        <div class="mt2 text-left">
           <w-flex class="mt3" wrap align-center justify-end  v-if="$zutil.anyRole(['4']) && form.lkp_status_anak_id == 34">
                  <w-button class="my1" bg-color="success" type="submit" :loading="form_anak.submitted && !form.sent" @click="send(1)"> <!-- 3 hantar semakan -->
                     <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
                  </w-button>
               </w-flex>

          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
     </z-page>
  </zen-one>
  
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.anak',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Permohonan Perkhidmatan', route: '/art' },
        { label: 'Lapor Kelahiran Anak AI/ET', route: '/art/anak' },
        { label: 'Papar', route: '/art/anak/'+this.id },
      ],
      title : 'Permohonan Pembiakan Perkhidmatan',
      form : {
        id : this.id,
        premis_id : '',
        tarikh_lahir : '',
        lkp_kaedah_kelahiran_id : '',
        lkp_gred_id : '',
        lkp_status_anak_id : '',
        nyatakan_status_anak : '',
        lkp_warna_id : '',
        anak : [
          {
            nama : '',
            jantina : '',
            jantina_label : '',
            berat : '',
            lkp_status_id : '',
            status_label : ''
          }
        ]
      },
      form_anak: {
        lkp_status_anak_id : '',
        nyatakan_status_anak : '',
      },
      
      attahecment : [],
      slides : [],
      gred : [],
      lkp_warna : [],
      
      
    }
  },
  methods: {
   
     getData(){
      if(this.form.id > 0){
        this.$zcomm.get(this.api_service + 'art/art_butiran/'+this.form.id, {}).then(res => {
          this.form = res
          
          this.getAttahecment() 

            // for (var h in this.form.anak) {

            // this.getAttahecmentAnak(this.form.anak[h].id);
            // }

        })
      }
    },
    
    
    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\ArtButiran'}).then(res => {
        this.attahecment = res
        this.slides = [];
       for (var b in this.attahecment) {
          this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
       }
      })
    },

    // getAttahecmentAnak(id)
    // {
    //   this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : id, model : '\\App\\Model\\ArtAnak'}).then(res => {
    //     this.attahecment = res
    //     this.slides = [];
    //    for (var b in this.attahecment) {
    //       this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
    //    }
    //   })
    // },

    tutup(){
      // if(this.form.lkp_art_id==1){
      //  this.$inertia.visit(this.$route('art.semakan.ai', this.form.art_id)+'?t=2');
      // }else if(this.form.lkp_art_id==2){
      //  this.$inertia.visit(this.$route('art.semakan.pd', this.form.art_id)+'?t=2');
      // }else if(this.form.lkp_art_id==3){
      //  this.$inertia.visit(this.$route('art.semakan.et', this.form.art_id)+'?t=2');
      // }else if(this.form.lkp_art_id==4){
      //  this.$inertia.visit(this.$route('art.semakan.sinkronisasi', this.form.art_id)+'?t=2');
      // }
      this.$inertia.visit(window.route('art.anak.index'));
       // this.$inertia.visit(this.$route('art.permohonan.show', this.form.art_id)+'?t=2');
    },
    

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",item);
       formData.append("model_id", this.form.id);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },

   getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.gred = res
      })
    },

    getWarna(){
         this.$zcomm.get(this.api_service + 'lookup/warna', {}).then(res => {
           this.lkp_warna = res
         })
       },

   send(hantar){
    // alert(hantar);
      this.form.hantar = hantar
      this.validateForm();
   },

   validateForm() {
    // alert(this.form_anak.lkp_status_anak_id)
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
         if(this.form.id > 0){ 

                if(!this.form.lkp_gred_id ||  !this.form_anak.lkp_status_anak_id){
                    isValid = false;
                }
                if(!this.form_anak.nyatakan_status_anak && this.form_anak.lkp_status_anak_id ==  21){
                    isValid = false;
                }
         }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },

     onSuccess(){
        if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
           }).then((result) => {
              if (result.value) {

                this.form.lkp_status_anak_id = this.form_anak.lkp_status_anak_id;
                this.form.nyatakan_status_anak = this.form_anak.nyatakan_status_anak;
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                  .then(res => {
                     this.$zutil.notify("Berjaya disimpan", true);
                     this.$inertia.visit(window.route('baka.anak.index'));
                  })
                  
                  .finally(() => {
                     this.loading = false;
                  });
              }else{ }
         })
      }
   },

    cetak(id)
    {
        window.open('cetak/'+id);
    },





  },

  watch: {

  },
  mounted() {
    this.getData()
    this.getWarna()
    this.getGred()
    if(this.id > 0)
    {
      this.title = ' Rekod Kelahiran Anak AI/ET'
    }
    else
    {
      this.title = ' Rekod Kelahiran Anak AI/ET'
    }
    
  }
    
}
</script>
